import React from 'react';
import { compose } from 'recompose';
import styled, { StylesProps } from '../../../../../lib/styles';
import Slider from '../../../../../components/presentational/Slider';
import Hero from '../../../../../components/presentational/Hero';
import { Brand } from '../../../store/selectors';
import Spacer from '../../../../../components/presentational/Spacer';
import { trackEvent } from '../../../../../lib/ga';
import { CTA_BLOCK_CLICKED } from '../../../lib/ga';
import { withQuery } from '../../../../../lib/stringUtils';
import theme from '../../../../../lib/theme';

import ctaBlockStyles from './CTABlock_styles';

const { isArray } = Array;

const { colors } = theme;

interface CTABlockGalleryImage {
  path: string;
  description?: string;
}

export interface CTABlockData {
  type: 'cta_block';
  backgroundImage?: string;
  logo?: string;
  title: string;
  subtitle?: string;
  description?: string;
  terms?: string;
  ctaColumns?: boolean;
  ctas?: {
    url: string;
    text: string;
  }[];
  gallery?: CTABlockGalleryImage[];
}

export interface CTABlockProps {
  uid?: string;
  block: CTABlockData;
  brand: Brand;
}

const isTypeformURL = (url: string) => url ? url.includes('typeform.com') : false;

const CTABlock = ({
  block: {
    backgroundImage,
    logo,
    title,
    subtitle,
    description,
    terms,
    ctaColumns,
    ctas = [],
    gallery = [],
  },
  uid,
  styles,
}: CTABlockProps & StylesProps<typeof ctaBlockStyles>) => (
  <div className={styles.container}>
    <Spacer width={1160}>
      <div className={styles.columns}>
        {isArray(gallery) && gallery.length > 0 && (
          <Spacer width={660}>
            <Slider
              brand={'sas'}
              images={gallery}
              aspectRatio={9 / 16}
              minWidth={320}
              maxWidth={660}
            />
          </Spacer>
        )}

        <Spacer flex={'auto'}>
          <Hero
            imageURL={backgroundImage}
            logoURL={logo}
            title={title}
            subtitle={subtitle}
            description={description}
            terms={terms}
            ctaColumns={ctaColumns}
            ctas={ctas.map(({ url, ...cta }) => ({
              ...cta,

              url: uid && isTypeformURL(url) ? withQuery(url, { uid }) : url,
            }))}
            onClick={url =>
              trackEvent(
                { ...CTA_BLOCK_CLICKED, label: url },
                { transport: 'beacon' }
              )
            }
            overlayColor={colors.black}
          />
        </Spacer>
      </div>
    </Spacer>
  </div>
);

export default compose(styled(ctaBlockStyles))(CTABlock);
